export class SsoLoginErrorService {
	public errorDetails: { details: string, stackTrace: string }

	/*@ngInject*/
	constructor(private $location: ng.ILocationService) {
	}

	handleError(response, idp: string) {
		let message = response.data && (response.data.message || response.data.details);
		let details = response.data && response.data.details;
		let stackTrace = response.data && response.data.stackTrace;

		this.errorDetails = { details: details, stackTrace: stackTrace };

		this.$location.path(`/authorize/sso/${idp}/error`).search({ message: message });

		return Promise.reject(response);
	}
}